import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SubmitEntityData } from 'globals/store/share.data';
import { ShareWrapper } from './share-wrapper.component';
import { CustomQuestion } from 'globals/store/events.data';
import { Exhibitor } from 'globals/store/exhibitors.data';
import { BrandingData } from 'globals/store/publish.data';
import { ExhibitorEditFormComponent } from './share.editExhibitorForm.component';
import { CommonModule } from '@angular/common';
import { BrandingWrapperComponent } from 'src/app/components/branding/branding-wrapper.component';

@Component({
    selector: 'share-submit-exhibitor',
    template: `
<branding-wrapper
  [brandingData]="brandingData" 
  [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'">
  <div *ngIf="loading" class="loading">Loading...</div>
  <div *ngIf="!loading && !exhibitor" [innerHTML]="helpers.strWithBreak(inactiveUrlMessage)" class="sorry"></div>
  <div *ngIf="submitted"  class="thanks">
    Thank you! Your profile information has been submitted.
  </div>
  <share-edit-exhibitor-form *ngIf="!!exhibitor && !submitted"
    [topTitle]="(templateTitle || 'Call to Submit Exhibitors') + ': ' + (eventName || 'Unnamed Event')"
    [eventId]="eventId"
    [exhibitor]="exhibitor"
    [publishCode]="templateId"
    [customQuestions]="customQuestions"
    [instructions]="instructions"
    [error]="error"
    [processing]="processing"
    [callToSubmit]="true"
    [template]="template"
    (onSubmit)="submit()">
  </share-edit-exhibitor-form>
</branding-wrapper>
    `,
    styleUrls: ['./share.editPerformer.scss'],
    standalone: true,
    imports: [ExhibitorEditFormComponent, CommonModule, BrandingWrapperComponent],
})
export class ExhibitorSubmitComponent extends ShareWrapper<ExhibitorSubmitComponent> {
  templateId: string
  submitted: boolean
  eventId: string
  eventName: string
  templateTitle: string
  cannotSubmitMessage = "A new exhibitor profile can't be submitted at this time."
  exhibitor: Exhibitor
  inactiveUrlMessage = "This call for new exhibitors is not currently available."
  customQuestions: CustomQuestion[] = []
  instructions: string
  brandingData: BrandingData

  constructor(private route:ActivatedRoute) {
    super()
    this.loading = true;
    document.title = "loading";

    this.route.params.subscribe(params=>{
      const { eventId, templateId } = params;
      if (!eventId || !templateId) {
        this.loading = false;
        document.title = "Unavailable";
        return
      }
      this.templateId = templateId
      this.eventId = eventId
      const queryData: SubmitEntityData = { entityType: 'exhibitor', submitTemplateId: templateId, eventId }
      this.publicService.loadSubmitEntityExtraData(queryData).then(data => {
        if (!data) {
          this.cannotLoad()
          return
        }
        const { eventTitle, customQuestions, templateTitle, instructions, brandingData } = data
        this.instructions = instructions
        this.loading = false
        this.exhibitor =  {
          social: [],
          labels: [],
          customQuestions: {},
          name: '',
        }
        this.brandingData = brandingData
        this.template = brandingData?.template
        
        this.eventName = eventTitle
        this.customQuestions = customQuestions
        this.templateTitle = templateTitle
        document.title = `Call for new exhibitors`;
      }).catch(this.cannotLoad.bind(this))          
    })
  }



  cannotLoad(errorResponse = '') {
    if (errorResponse) console.error(errorResponse)
    this.loading = false
    this.showError(this.inactiveUrlMessage)
  }


  async submit() {
    const { templateId, eventId, exhibitor } = this
    const submitData: SubmitEntityData = { entityType: 'exhibitor', submitTemplateId: templateId, eventId, entity: exhibitor }
    console.log({ submitData })
    await this.submitEntity(submitData, this.cannotSubmitMessage)
  }
}

